import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";

import closeUpBg1 from "../../../assets/loan-interactive/closeUpBg/vendor-01_close-up.png";
import CustomMessageDialog from "./CustomMessageDialog";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Intro({ buttonGoMarketElement, objData, pageLang }) {
  useEffect(() => {}, []);
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });
  return (
    <div
      style={{
        position: md ? "absolute" : "inherit",
        width: "100%",
        height: "100%",
        paddingTop: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFFFFF40",
          height: "80%",
          padding: "1.5rem",
          borderRadius: "1rem",
          width: "70%",
          marginLeft: "15%",
        }}
      >
        <CustomMessageDialog
          buttonElement={buttonGoMarketElement}
          objData={objData}
          pageLang={pageLang}
          mainContainer={{
            height: md ? "inherit" : "400px",
            flexGrow: "1",
          }}
        />
      </Box>
    </div>
  );
}

export default Intro;
